import React, { useEffect } from 'react';
import { useLocation, matchRoutes } from 'react-router-dom';
import { AnalyticsContext, useAnalytics } from '@backstage/core-plugin-api';

const getExtensionContext = (pathname, routes) => {
  try {
    const matches = matchRoutes(routes, { pathname });
    const routeMatch = matches == null ? void 0 : matches.filter((match) => {
      var _a;
      return ((_a = match == null ? void 0 : match.route.routeRefs) == null ? void 0 : _a.size) > 0;
    }).pop();
    const routeObject = routeMatch == null ? void 0 : routeMatch.route;
    if (!routeObject) {
      return void 0;
    }
    if (routeObject.path === "" && pathname !== "/") {
      return void 0;
    }
    let routeRef;
    if (routeObject.routeRefs.size === 1) {
      routeRef = routeObject.routeRefs.values().next().value;
    }
    let plugin;
    if (routeObject.plugins.size === 1) {
      plugin = routeObject.plugins.values().next().value;
    }
    const params = Object.entries(
      (routeMatch == null ? void 0 : routeMatch.params) || {}
    ).reduce((acc, [key, value]) => {
      if (value !== void 0 && key !== "*") {
        acc[key] = value;
      }
      return acc;
    }, {});
    return {
      extension: "App",
      pluginId: (plugin == null ? void 0 : plugin.getId()) || "root",
      ...routeRef ? { routeRef: routeRef.id } : {},
      _routeNodeType: routeObject.element,
      params
    };
  } catch {
    return void 0;
  }
};
const TrackNavigation = ({
  pathname,
  search,
  hash,
  attributes
}) => {
  const analytics = useAnalytics();
  useEffect(() => {
    analytics.captureEvent("navigate", `${pathname}${search}${hash}`, {
      attributes
    });
  }, [analytics, pathname, search, hash, attributes]);
  return null;
};
const RouteTracker = ({
  routeObjects
}) => {
  const { pathname, search, hash } = useLocation();
  const { params, ...attributes } = getExtensionContext(
    pathname,
    routeObjects
  ) || { params: {} };
  return /* @__PURE__ */ React.createElement(AnalyticsContext, { attributes }, /* @__PURE__ */ React.createElement(
    TrackNavigation,
    {
      pathname,
      search,
      hash,
      attributes: params
    }
  ));
};

export { RouteTracker };
//# sourceMappingURL=RouteTracker.esm.js.map
